<ui-page-container size="medium">
  <mat-card>
    <mat-card-title>{{ 'Gestione vocabolari' | translate }}</mat-card-title>
    <mat-card-content>
      <p>
        {{ 'Lista dei vocabolari utilizzati durante l\'inserimento dei beni.' | translate }}
      </p>
      <p>
        {{ 'Ad ogni vocabolario possono essere aggiunti o rimossi termini.' | translate }}
      </p>

      <mat-form-field
        class="input-expanse"
        appearance="outline">
        <input
          matInput
          #vocabularySearchElement
          [placeholder]="'Cerca un vocabolario'">
      </mat-form-field>

      <mat-accordion [@.disabled]="true">
        <mat-expansion-panel
          *ngFor="let vocabulary of vocabularies$ | async | filterObj : 'nome' : vocabularySearchElement.value; trackBy: trackByName"
          (opened)="openSectionHandler(vocabulary)">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ vocabulary.nome }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div
            *ngIf="vocabulary.id === activeVocabulary?.id && !isAdvancedVocabularyHandler(vocabulary)"
            class="terms-container">
            <ng-container *ngIf="activeTerms$ | async as activeTerms; else loading">
              <mat-form-field
                class="input-expanse"
                appearance="outline">
                <input
                  matInput
                  #termSearchElement
                  [placeholder]="'Cerca un termine'"
                  (keyup)="searchTermHandler(termSearchElement.value)">
              </mat-form-field>

              <mat-action-list *ngIf="!isOpening; else loading">
                <mat-list-item *ngFor="let term of activeTerms?.data; trackBy: trackByName">
                  <mat-icon
                    *roleVisibility="['delete']; classNames: ['Termine']"
                    mat-list-icon
                    (click)="deleteTermHandler(vocabulary, term)">
                    delete
                  </mat-icon>
                  <p mat-line>{{ term?.valore }}</p>
                </mat-list-item>
              </mat-action-list>

              <ui-no-items
                *ngIf="activeTerms?.data.length === 0 && !isOpening"
                [size]="42"
                [message]="'Nessun termine trovato' | translate">
              </ui-no-items>

              <mat-paginator
                [length]="activeTerms?.count"
                [pageIndex]="activeTerms?.params?.skip / activeTerms?.params?.limit"
                [pageSize]="activeTerms?.params?.limit"
                [pageSizeOptions]="pageSizeOptions"
                (page)="changePageHandler($event)">
              </mat-paginator>
            </ng-container>

            <ng-template #loading>
              <div class="loading-container">
                <ngx-spinner
                  [fullScreen]="false"
                  name="loadingTerms"
                  type="square-loader"
                  size="medium"
                  class="loading-spinner">
                </ngx-spinner>
              </div>
            </ng-template>

            <div
              *roleVisibility="['create']; classNames: ['Termine']"
              class="new-term-form">
              <mat-form-field>
                <input
                  matInput
                  #newTermInput
                  [placeholder]="'Nuovo termine' | translate">
              </mat-form-field>
              <button
                mat-button
                mat-raised-button
                color="primary"
                type="button"
                (click)="addTermHandler(newTermInput.value, vocabulary); newTermInput.value = ''">
                {{ 'Aggiungi termine' | translate }}
              </button>
            </div>
          </div>
          <div *ngIf="vocabulary.id === activeVocabulary?.id && isAdvancedVocabularyHandler(vocabulary)">
            <p>{{ 'Gestisci in maniera avanzata questo vocabolario.' | translate }}</p>
            <p>{{ 'E\' possibile aggiungere/rimuovere termini e creare dei termini annidati.' | translate }}</p>
            <button
              mat-button
              mat-raised-button
              type="button"
              (click)="openAdvancedVocabularyHandler(vocabulary)">
              {{ 'Gestisci vocabolario' }}
            </button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </mat-card>
</ui-page-container>
